/**
 * Transparent Header Overlay
 * Handles transparent header styling on all pages
 */

class TransparentHeader {
  constructor() {
    this.headerWrapper = document.querySelector('.header-wrapper');
    this.stickyHeader = document.querySelector('sticky-header');
    this.init();
  }

  init() {
    if (!this.headerWrapper) return;

    // Always enable transparent mode on all pages
    this.enableTransparentMode();

    // Check if first section after header is hero-media
    const sections = document.querySelectorAll('.shopify-section');
    let heroSection = null;

    for (let section of sections) {
      if (section.querySelector('.hero-media')) {
        heroSection = section;
        break;
      }
    }

    if (heroSection) {
      heroSection.classList.add('section-hero-media-first');
      this.headerWrapper.classList.add('has-hero');
      this.setupScrollListener();
    } else {
      // If no hero section, start with solid background (scrolled state)
      this.headerWrapper.classList.add('scrolled-past-header');
      // Make header non-overlapping for non-hero pages
      this.headerWrapper.style.position = 'relative';
      this.headerWrapper.style.background = '#ffffff';
      this.setupScrollListener();
    }
  }

  enableTransparentMode() {
    this.headerWrapper.classList.add('header-wrapper--transparent');

    // Also add to parent section-header if exists
    const sectionHeader = this.headerWrapper.closest('.section-header');
    if (sectionHeader) {
      sectionHeader.classList.add('section-header--transparent');
    }
  }

  setupScrollListener() {
    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    // Initial check
    this.handleScroll();
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const threshold = 100; // Adjust this value to control when the header becomes solid

    if (scrollTop > threshold) {
      this.headerWrapper.classList.add('scrolled-past-header');
    } else {
      this.headerWrapper.classList.remove('scrolled-past-header');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TransparentHeader();
  });
} else {
  new TransparentHeader();
}
